module.exports = __webpack_public_path__ + "img/result.f4f9ef9d.gif";